import { MealTime } from "@/clients/models/MealTime";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

interface RemoveFavouriteMealRequest {
  meal_id: string;
  meal_time: MealTime;
}

export const useRemoveFavouriteMeal = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [QueryKeys.FAVORITE_MEALS, "remove"],
    mutationFn: async (requestBody: RemoveFavouriteMealRequest) => {
      const user = guardGetUserFromLocalStorage();
      return MealsService.removeFavouriteMealApiV1MealsFavouritesDelete(user.id, requestBody);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.FAVORITE_MEALS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.MY_FOODS] });
    },
  });

  return {
    removeFavouriteMeal: mutation.mutate,
    removeFavouriteMealAsync: mutation.mutateAsync,
    isRemovingFavouriteMeal: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    response: mutation.data,
  };
};
